//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import { Button   } from '@mui/material';

// === HOOKS ===
import { useTaskMonitoring } from 'pages/Admin/ServerPanel/hooks/useMonitorStatus';

// === API ===
import { stopTaskMonitor, startTaskMonitor } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function TaskMonitorButton() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();
  const [is_monitoring] = useTaskMonitoring();

  const color = is_monitoring ? theme.palette.error.main : theme.palette.success.main;
  const label = is_monitoring ? 'Stop Monitoring' : 'Start Monitoring';
  
  //#endregion

  //#region [STYLES]

  const _styles = {
    monitor_button: {
      flex     : '1 1 23%' ,
      minWidth : '10rem'   ,
      margin   : '0.5rem'  ,
      backgroundColor  : color , 
    }
  }

  const MONITOR_BUTTON = {
    sx       : _styles.monitor_button,
    variant  : 'contained' ,
    color    : 'primary'   ,
    onClick  : handleClick ,
    children : [ label ]   ,
    name     : 'toggle_system_monitor_btn'
  }

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
   function handleClick() {
    //-----------------------------------------------------------------
    const toggle = is_monitoring ? stopTaskMonitor: startTaskMonitor;
    toggle(); 
  }
  
  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return <Button { ...MONITOR_BUTTON } />
  };

  //#endregion

  return display();
}